import { useSpring } from "react-spring";
import { useCallback } from "react";

export const useClampedSpring = (initialValue = 0) => {
  const [props, _set, stop] = useSpring(() => ({
    value: initialValue
  }));
  const set = useCallback(
    ({ value, immediate = false, onStop }) => {
      let hasStopped = false;
      const handleStop = () => {
        if (!hasStopped) {
          hasStopped = true;
          stop();
          onStop && onStop();
        }
      };
      _set({
        to: { value },
        immediate,
        clamp: true,
        precicion: 0.2,
        onRest: handleStop,
        onFrame: obj => {
          if (
            !immediate &&
            obj.value !== value &&
            !(obj.value > value + 3 || obj.value < value - 3)
          ) {
            handleStop();
          }
        }
      });
    },
    [_set, stop]
  );
  return [props, set, stop];
};
